import React, { useState, useEffect } from "react";
import MapPage from "../MapPage";
import { getQuoteById } from "../../utils/api/quote";
import { getCompanyById } from "../../utils/api/company";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateField } from "../../utils/customerSlice";
import { setCompanyData } from "../../utils/companySlice";
import { getAllCollection } from "../../utils/api/options";
import { timestampToISO } from "../../utils/helperFunctions";
import { setGlobalData } from "../../utils/companySlice";
import AccountDisabledPage from "../AccountDisabledPage";
// import { useSelector } from "react-redux";

export default function MapPageContainer() {
  const dispatch = useDispatch();
  const [foundQuote, setFoundQuote] = useState(null);
  const { quoteId } = useParams();
  const navigate = useNavigate();
  // get companyId
  // const companyId = useSelector((state) => state.company.id);

  useEffect(() => {
    getQuoteById(quoteId)
      .then((quote) => {
        if (!quote) {
          navigate("/404");
        }
        setFoundQuote({ id: quoteId, ...quote });
        dispatch(
          updateField({
            field: "details",
            value: { id: quoteId, ...quote },
          })
        );

        const companyId = quote.companyId;

        getCompanyById(quote.companyId)
          .then((company) => {
            dispatch(updateField({ field: "company", value: company }));
            dispatch(setCompanyData(company));
          })
          .catch((err) => {
            console.log("Couldn't find company: ", err);
          });

        getAllCollection("styles", companyId)
          .then((res) => {
            const newDataList = res.map((option) => {
              return {
                ...option,
                createdAt: timestampToISO(option.createdAt),
              };
            });
            dispatch(
              setGlobalData({
                data: newDataList,
                listName: "globalStylesList",
                mapName: "globalStylesMap",
              })
            );
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });

        getAllCollection("materials", companyId)
          .then((res) => {
            const newDataList = res.map((option) => {
              return {
                ...option,
                createdAt: timestampToISO(option.createdAt),
              };
            });
            dispatch(
              setGlobalData({
                data: newDataList,
                listName: "globalMaterialsList",
                mapName: "globalMaterialsMap",
              })
            );
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });

        getAllCollection("attributes", companyId)
          .then((res) => {
            const newDataList = res.map((option) => {
              return {
                ...option,
                createdAt: timestampToISO(option.createdAt),
              };
            });
            dispatch(
              setGlobalData({
                data: newDataList,
                listName: "globalAttributesList",
                mapName: "globalAttributesMap",
              })
            );
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });

        getAllCollection("items", companyId)
          .then((res) => {
            const newDataList = res.map((option) => {
              return {
                ...option,
                createdAt: timestampToISO(option.createdAt),
              };
            });
            dispatch(
              setGlobalData({
                data: newDataList,
                mapName: "globalItemsMap",
                listName: "globalItemsList",
              })
            );
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => console.log("Couldn't find quote: ", err));
  }, []);

  if (!foundQuote) {
    return <AccountDisabledPage />;
  }
  return <MapPage quoteData={foundQuote} />;
}
